import { call, put, takeLatest } from "redux-saga/effects";

// action
import {
  GET_ARTICLE_TAGS,
  getArticleTagsSuccess,
  getArticleTagsFail,
} from "../action/getArticleTagsAction";

// api
import getArticleTagsApi from "../api/getArticleTagsApi";

export function* getArticleListSaga(action) {
  try {
    const response = yield call(() => getArticleTagsApi(action.params));
    if (response.data.status === 1) {
      yield put(getArticleTagsSuccess(response, action));
    } else {
      yield put(getArticleTagsFail(response, action));
    }
  } catch (e) {
    yield put(getArticleTagsFail(e.response, action));
  }
}

export default function* mySaga() {
  yield takeLatest(GET_ARTICLE_TAGS, getArticleListSaga);
}
